import React from 'react'
import "../App.css"


const MovieList = (props) => {
   const FavoriteComponent = props.favoriteComponent;

  return (
    <div className='movie-list'>
            <div className='d-flex justify-content-start gap-3'>
            {props.movies.map((movie, index) =>(
            <div className='height image-container' key={index}>
                <img src={movie.Poster} alt={movie.Title}/>
                <div className='overlay d-flex align-items-center justify-content-center' onClick={()=>props.handleFavoriteClick(movie)}>
                    <FavoriteComponent/>
                </div>
            </div> 
            ))}
        </div>
    </div>
  )
}

export default MovieList
